export const settingsPl = {
  settings: {
    common: {
      save: 'Zapisz',
      add: 'Dodaj',
      edit: 'Edytuj',
      cancel: 'Anuluj',
    },
    page: {
      title: 'Ustawienia',
      subtitle: 'Zarządzaj preferencjami i własnymi kategoriami',
      save: 'Zapisz',
      error_prefix: 'Błąd ładowania ustawień',
      sections: {
        preferences: {
          title: 'Preferencje',
          description: 'Zarządzaj ogólnymi preferencjami i ustawieniami',
        },
        theme: {
          label: 'Motyw',
          subtitle: 'Wybierz jasny lub ciemny motyw',
          placeholder: 'Wybierz motyw',
          group_label: 'Motyw',
          options: {
            light: 'Jasny',
            dark: 'Ciemny',
          },
        },
        locale: {
          label: 'Język',
          subtitle: 'Język używany w interfejsie',
          placeholder: 'Wybierz język',
          group_label: 'Język',
          options: {
            en: 'English',
            pl: 'Polski',
          },
        },
        defaultContainersPublic: {
          label: 'Nowe kontenery domyślnie publiczne',
          subtitle: 'Po włączeniu, nowo utworzone kontenery będą domyślnie publiczne',
        },
        profilePublic: {
          label: 'Udostępnij profil publicznie',
          subtitle: 'Pozwól innym zalogowanym użytkownikom przeglądać Twój publiczny profil',
        },
        emailPublic: {
          label: 'Pokaż email w profilu publicznym',
          subtitle: 'Wyświetlaj swój adres email w profilu publicznym (tylko jeśli profil jest publiczny)',
        },
      },
    },
    security: {
      title: 'Bezpieczeństwo',
      description: 'Zarządzaj bezpieczeństwem konta i uwierzytelnianiem dwuskładnikowym',
      setup: 'Włącz 2FA',
      manage: 'Zarządzaj 2FA',
      login_required: 'Zaloguj się, aby zarządzać ustawieniami bezpieczeństwa i uwierzytelnianiem dwuskładnikowym.',
      not_configured: 'Uwierzytelnianie dwuskładnikowe nie jest włączone. Włącz je dla lepszego bezpieczeństwa.',
      totp: {
        title: 'Aplikacja uwierzytelniająca',
        enabled: 'Włączona',
        disabled: 'Nie skonfigurowana',
      },
      passkeys: {
        title: 'Klucze dostępu',
        enabled: 'Włączone',
        disabled: 'Nie skonfigurowane',
        count: '{count} kluczy dostępu | {count} klucz dostępu | {count} klucze dostępu | {count} kluczy dostępu',
      },
      preferred_method: {
        title: 'Preferowana metoda 2FA',
        description: 'Ustaw preferowaną metodę uwierzytelniania dwuskładnikowego',
        label: 'Preferowana metoda',
        placeholder: 'Wybierz preferowaną metodę',
        options: {
          none: 'Automatycznie',
          totp: 'Aplikacja uwierzytelniająca',
          webauthn: 'Klucze dostępu',
        },
        saved: 'Zaktualizowano preferowaną metodę',
        error: 'Nie udało się zaktualizować preferowanej metody',
      },
    },
    preferences: {
      title: 'Preferencje Sprzętu',
      description: 'Zarządzaj preferencjami i ustawieniami dotyczącymi sprzętu',
      save: 'Zapisz',
      saved: 'Zapisano',
      preferredWeightUnit: {
        label: 'Preferowana Jednostka Wagi',
        subtitle: 'Domyślna jednostka wyświetlania wag w całej aplikacji',
        placeholder: 'Wybierz jednostkę wagi',
        options: {
          g: 'Gramy (g)',
          kg: 'Kilogramy (kg)',
          oz: 'Uncje (oz)',
          lb: 'Funty (lb)',
          'auto-g-kg': 'Auto (g/kg)',
          'auto-oz-lb': 'Auto (oz/lb)',
        },
      },
      defaultCurrency: {
        label: 'Domyślna Waluta',
        subtitle: 'Domyślna waluta dla cen w przedmiotach i kontenerach',
        placeholder: 'Wybierz walutę',
      },
      imageProcessingMode: {
        label: 'Tryb Przetwarzania Obrazków',
        subtitle: 'Wybierz sposób przetwarzania przesyłanych obrazków (zmiana rozmiaru i kompresja)',
        options: {
          highQuality: 'Wysoka Jakość',
          highQualityDescription: 'Maksymalny rozmiar: 2560x2560px, jakość JPEG: 95%. Najlepsza jakość, większy rozmiar pliku.',
          balanced: 'Zbalansowany',
          balancedDescription: 'Maksymalny rozmiar: 1200x1200px, jakość JPEG: 90%. Dobra równowaga między jakością a rozmiarem pliku.',
          storageSaver: 'Oszczędny',
          storageSaverDescription: 'Maksymalny rozmiar: 800x800px, jakość JPEG: 80%. Mniejszy rozmiar pliku, niższa jakość.',
        },
      },
    },
    categories: {
      title: 'Własne Kategorie',
      description: 'Dodawaj i zarządzaj własnymi kategoriami przedmiotów',
      add: 'Dodaj Kategorię',
      edit: 'Edytuj Kategorię',
      save: 'Zapisz',
      cancel: 'Anuluj',
      deleteConfirm: 'Czy na pewno chcesz usunąć tę kategorię?',
      valuePlaceholder: 'Nazwa kategorii',
      valueRequired: 'Nazwa kategorii jest wymagana',
      empty: 'Brak własnych kategorii. Dodaj pierwszą powyżej.',
    },
    containerTypes: {
      title: 'Własne Typy Kontenerów',
      description: 'Dodawaj i zarządzaj własnymi typami kontenerów',
      add: 'Dodaj Typ Kontenera',
      edit: 'Edytuj Typ Kontenera',
      save: 'Zapisz',
      cancel: 'Anuluj',
      deleteConfirm: 'Czy na pewno chcesz usunąć ten typ kontenera?',
      valuePlaceholder: 'Nazwa typu kontenera',
      valueRequired: 'Nazwa typu kontenera jest wymagana',
      empty: 'Brak własnych typów kontenerów. Dodaj pierwszy powyżej.',
    },
    brands: {
      title: 'Własne Marki',
      description: 'Dodawaj i zarządzaj własnymi markami przedmiotów',
      add: 'Dodaj Markę',
      edit: 'Edytuj Markę',
      save: 'Zapisz',
      cancel: 'Anuluj',
      deleteConfirm: 'Czy na pewno chcesz usunąć tę markę?',
      valuePlaceholder: 'Nazwa marki',
      valueRequired: 'Nazwa marki jest wymagana',
      empty: 'Brak własnych marek. Dodaj pierwszą powyżej.',
    },
    visualizationZones: {
      title: 'Własne Obszary Wizualizacji',
      description: 'Dodawaj i zarządzaj własnymi obszarami na mapie kontenerów',
      add: 'Dodaj Obszar',
      empty: 'Brak własnych obszarów. Dodaj pierwszy powyżej.',
      openVisualization: 'Otwórz wizualizację',
    },
    oauth: {
      title: 'Połączenia OAuth',
      description: 'Zarządzaj powiązanymi kontami OAuth (Google, Facebook itp.)',
      login_required: 'Zaloguj się, aby zarządzać połączeniami OAuth.',
      no_connections: 'Brak powiązanych kont OAuth.',
      providers: {
        google: 'Google',
        facebook: 'Facebook',
      },
      connection: {
        linked: 'Połączone',
        deleted: 'Połączenie OAuth zostało usunięte',
        confirm_delete: 'Czy na pewno chcesz usunąć połączenie z {provider}?',
      },
    },
    storage: {
      title: 'Użycie Miejsca',
      description: 'Zobacz użycie i limity miejsca na pliki',
      used: 'Użyto',
      usagePercentage: 'Użycie',
      error: 'Nie można załadować informacji o miejscu',
    },
    delete_account: {
      title: 'Usuń Konto',
      description: 'Trwale usuń swoje konto i wszystkie powiązane dane',
      warning_title: 'Ostrzeżenie: Ta akcja nie może być cofnięta',
      warning_1: 'Wszystkie Twoje dane zostaną trwale usunięte',
      warning_2: 'Utracisz dostęp do wszystkich swoich kontenerów i przedmiotów',
      warning_3: 'Ta akcja nie może być odwrócona',
      button: 'Usuń Konto',
      modal: {
        title: 'Usuń Konto',
        description: 'Czy na pewno chcesz usunąć swoje konto? Ta akcja nie może być cofnięta.',
        warning_title: 'Ostatnie Ostrzeżenie',
        warning_text: 'Po usunięciu konta wszystkie Twoje dane zostaną trwale usunięte i nie będą mogły zostać odzyskane.',
        confirmation_label: 'Wpisz DELETE aby potwierdzić',
        confirmation_hint: 'Proszę wpisać DELETE w polu powyżej, aby potwierdzić usunięcie konta',
        confirm_checkbox: 'Rozumiem, że ta akcja nie może być cofnięta i wszystkie moje dane zostaną trwale usunięte',
        cancel: 'Anuluj',
        delete_button: 'Usuń Konto',
        success: 'Konto zostało pomyślnie usunięte',
        errors: {
          invalid_confirmation: 'Nieprawidłowe potwierdzenie. Proszę wpisać DELETE aby potwierdzić.',
          generic: 'Nie udało się usunąć konta. Proszę spróbować ponownie.',
        },
      },
    },
  },
}

